import React, { useRef, useState, useLayoutEffect } from 'react';
import styled, { keyframes } from 'styled-components';
import { NavLink as RouterNavLink } from 'react-router-dom';
import { gsap } from 'gsap';
import LogoImg from '../assets/logo.png';
import Icon1 from '../assets/icon1.svg';
import Icon2 from '../assets/icon2.svg';
import Icon3 from '../assets/icon3.svg';
import Icon4 from '../assets/icon4.svg';
import C1 from "../assets/card_hero_1.png"
import C2 from "../assets/card_hero_2.png"
import C3 from "../assets/card_hero_3.png"
import C4 from "../assets/card_hero_4.png"
import C5 from "../assets/card_hero_5.png"
import Background from '../assets/bg-red-home.png';
import BurgerImg from '../assets/Burger.svg';

const NavbarContainer = styled.nav`
  width: 100%;
  padding: 0 2rem;
  height: 60px;
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  position: relative;
  background: transparent;
  @media (max-width: 760px) {
    grid-template-columns: auto 1fr auto;
  }
`;

const LogoWrapper = styled(RouterNavLink)`
  justify-self: start;
  display: flex;
  align-items: center;
`;

const Logo = styled.img`
  height: 40px;
  cursor: pointer;
`;

const NavLinks = styled.div`
  display: flex;
  gap: 1.5rem;
  grid-column: 2;
  @media (max-width: 760px) {
    display: none;
  }
`;

const StyledNavLink = styled(RouterNavLink)`
  text-decoration: none;
  font-family: 'PoppinsMedium';
  color: #fff;
  font-weight: 500;
  transition: color 0.2s;
`;

const RightActions = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  justify-self: end;
  grid-column: 3;
  @media (max-width: 760px) {
    display: none;
  }
`;

const LanguageButton = styled.button`
  background: none;
  border: none;
  font-size: 0.9rem;
  color: #fff;
  cursor: pointer;
  font-family: 'PoppinsMedium';
`;

const DiscoverButton = styled.button`
  background: #fff;
  border: 1px solid #333;
  color: #000;
  border-radius: 20px;
  padding: 0.5rem 1rem;
  font-size: 1.2rem;
  font-weight: 600;
  cursor: pointer;
  text-decoration:none;
  font-family: 'MongoGrotesqueLight';
  transition: background-color 0.2s, color 0.2s;
`;

const BurgerButton = styled.button`
  display: none;
  background: transparent;
  border: none;
  cursor: pointer;
  z-index: 10;
  @media (max-width: 760px) {
    display: block;
    justify-self: end;
  }
`;

const BurgerIcon = styled.img`
  width: 30px;
  height: auto;
`;

const Overlay = styled.div`
  position: fixed;
  top: 0; left: 0;
  width: 100%; height: 100vh;
  background: rgba(0,0,0,0.5);
  backdrop-filter: blur(50px);
  -webkit-backdrop-filter: blur(50px);
  z-index:5;
  overflow:hidden;
`;

const MobileMenu = styled.div`
  position: absolute;
  top: 0; left: 0;
  width: 100%; height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1.5rem;
  background: rgba(0,0,0,0.5);
  z-index: 6;

  a, button {
    color: #fff;
    font-size: 1.2rem;
  }
  ${DiscoverButton} {
    background: #fff;
    color: #000;
  }
`;

const PageContainer = styled.div`
  background: url(${Background}) no-repeat center/cover;
  display: flex;
  flex-direction: column;
  overflow:hidden;
  padding-bottom: 5%;
  @media (max-width: 760px) {
    overflow:hidden;
  }
`;

const Content = styled.div`
  flex: 1;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;

const TitleRow = styled.div`
  display: flex;
  gap: 1rem;
  margin-bottom: 1rem;
  @media (max-width: 1024px) {
    flex-direction:column;
    gap: 0rem;
    margin-bottom: 0.3rem;
  }
  @media (max-width: 375px) {
    flex-direction:row;
    gap: 1rem;
    margin-bottom: 1rem;
  }
`;

const TitleWord = styled.p`
  font-size: 9rem;
  color: #fff;
  font-family: 'MongoGrotesqueLight';
  margin: -1.5% 0;

  /* hide until GSAP makes it visible */
  visibility: hidden;
  @media (max-width: 760px) {
    font-size: 6rem;
  }
  @media (max-width: 410px) {
    font-size: 4rem;
  }
`;

const TitleWrapper = styled.div`
  overflow: hidden;
  display: inline-block;
`;

const Subtitle = styled.p`
  font-size: 1.1rem;
  color: #ddd;
  font-family: 'PoppinsMedium';
  margin: 0;

  /* hide until GSAP makes it visible */
  visibility: hidden;
  @media (max-width: 410px) {
    font-size: 0.9rem;
  }
`;

const SubtitleWrapper = styled.div`
  overflow: hidden;
  display: inline-block;
  height: 25px;
  margin-top: -20px;
  margin-bottom: 15px;
  @media (max-width: 760px) {
    height: 60px;
    margin-bottom: 10px;
    margin-top: 5px;
  }
  @media (max-width: 410px) {
    height: 45px;
    margin-bottom: 10px;
  }
`;

const IconRow = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: center;
  gap: 10px;
  margin-bottom: 1rem;
  @media (max-width: 760px) {
    margin-bottom: 1rem;
  }
`;

const fadeIn = keyframes`
  from { opacity: 0; }
  to   { opacity: 1; }
`;

const IconRow2 = styled.div`
  display: flex;
  justify-content: center;
  gap: 30px;
  align-items: flex-end;
  width: 100%;
  height: 320px;
  padding: 0 5%;
  @media (min-width: 1500px) {
    height: 320px;
  }
@media only screen
and (min-device-width: 820px)
and (max-device-width: 1024px) {
  height: 380px;
}
@media (max-width: 760px) {
  height: 200px;
}
`;

const IconCard = styled.img`
  width: 250px;
  height: 250px;
  object-fit: contain;
  opacity: 0;
  animation: ${fadeIn} 0.5s ease forwards paused;

  &:nth-child(1) {
    transform: rotate(22.71deg);
    animation-delay: 0s;
    margin-bottom: 80px;
    animation-timing-function: ease-in-out;
  }
  &:nth-child(2) {
    transform: rotate(11.1deg);
    animation-delay: 0.1s;
    margin-bottom: 20px;
    animation-timing-function: ease-in-out;
  }
  &:nth-child(3) {
    transform: rotate(0deg);
    animation-delay: 0.2s;
    margin-bottom: 0px;
    animation-timing-function: ease-in-out;
  }
  &:nth-child(4) {
    transform: rotate(-11.37deg);
    animation-delay: 0.3s;
    margin-bottom: 20px;
    animation-timing-function: ease-in-out;
  }
  &:nth-child(5) {
    transform: rotate(-20.98deg);
    animation-delay: 0.4s;
    margin-bottom: 80px;
    animation-timing-function: ease-in-out;
  }
  @media (min-width: 1500px) {
    width: 250px;
    height: 250px;
    &:nth-child(1) {
      transform: rotate(22.71deg);
      animation-delay: 0s;
      margin-bottom: 100px;
      animation-timing-function: ease-in-out;
    }
    &:nth-child(2) {
      transform: rotate(11.1deg);
      animation-delay: 0.1s;
      margin-bottom: 20px;
      animation-timing-function: ease-in-out;
    }
    &:nth-child(3) {
      transform: rotate(0deg);
      animation-delay: 0.2s;
      margin-bottom: 0px;
      animation-timing-function: ease-in-out;
    }
    &:nth-child(4) {
      transform: rotate(-11.37deg);
      animation-delay: 0.3s;
      margin-bottom: 20px;
      animation-timing-function: ease-in-out;
    }
    &:nth-child(5) {
      transform: rotate(-20.98deg);
      animation-delay: 0.4s;
      margin-bottom: 100px;
      animation-timing-function: ease-in-out;
    }
  }

 @media only screen
  and (min-device-width: 820px)
  and (max-device-width: 1024px) {
    width: 250px;
    height: 250px;
}
  @media (max-width: 760px) {
    width: 160px;
    height: 160px;
  }
  @media (max-width: 400px) {
    width: 140px;
    height: 140px;
  }
 
`;

const Icon = styled.img`
  width: 20px;
  height: 20px;
`;

const PageCard: React.FC = () => {
  const word1Ref = useRef<HTMLParagraphElement>(null);
  const word2Ref = useRef<HTMLParagraphElement>(null);
  const subtitleRef = useRef<HTMLParagraphElement>(null);
  const [isOpen, setIsOpen] = useState(false);

  useLayoutEffect(() => {
    let tl: ReturnType<typeof gsap.timeline> | null = null;

    const startAnim = () => {
      document
        .querySelectorAll<HTMLImageElement>('#card-row img')
        .forEach(img => {
          img.style.animationPlayState = 'running';
        });

      if (word1Ref.current && word2Ref.current && subtitleRef.current) {
        gsap.set(
          [word1Ref.current, word2Ref.current, subtitleRef.current],
          { yPercent: 100, visibility: 'visible' }
        );

        // Faster sequence: 0.5s fade + 0.4s max delay = 0.9s
        const cardsDoneAt = 0.9;

        tl = gsap.timeline({ delay: cardsDoneAt })
          .to(subtitleRef.current, {
            yPercent: 0,
            duration: 0.6,
            ease: 'power4.out',
          })
          .to(word1Ref.current, {
            yPercent: 0,
            duration: 0.6,
            ease: 'power4.out',
          }, '-=0.2')
          .to(word2Ref.current, {
            yPercent: 0,
            duration: 0.6,
            ease: 'power4.out',
          }, '-=0.15');
      }
    };

    window.addEventListener('pageTransitionFinished', startAnim, { once: true });
    return () => {
      window.removeEventListener('pageTransitionFinished', startAnim);
      if (tl) tl.kill();
    };
  }, []);

  return (
    <PageContainer>
      <NavbarContainer>
        <LogoWrapper to="/">
          <Logo src={LogoImg} alt="Logo" />
        </LogoWrapper>
        <NavLinks>
          <StyledNavLink to="/aboutus">À PROPOS DE NOUS</StyledNavLink>
          <StyledNavLink to="/jockerclub">JOKER CLUB</StyledNavLink>
          <StyledNavLink to="/">MULTISHOP</StyledNavLink>
          <StyledNavLink to="/contactus">CONTACT</StyledNavLink>
        </NavLinks>
        <RightActions>
          <LanguageButton>ENG</LanguageButton>
          <DiscoverButton onClick={() => window.open('https://linktr.ee/jokerclubspirit', '_blank')}>JE DÉCOUVRE</DiscoverButton>
        </RightActions>
        <BurgerButton onClick={() => setIsOpen(!isOpen)}>
          <BurgerIcon src={BurgerImg} alt="Menu" />
        </BurgerButton>
      </NavbarContainer>

      {isOpen && (
        <>
          <Overlay onClick={() => setIsOpen(false)} />
          <MobileMenu>
            <StyledNavLink to="/aboutus" onClick={() => setIsOpen(false)}>
              À PROPOS DE NOUS
            </StyledNavLink>
            <StyledNavLink to="/jockerclub" onClick={() => setIsOpen(false)}>
              JOKER CLUB
            </StyledNavLink>
            <StyledNavLink to="/" onClick={() => setIsOpen(false)}>
              MULTISHOP
            </StyledNavLink>
            <StyledNavLink to="/contactus" onClick={() => setIsOpen(false)}>
            CONTACTEZ-NOUS
          </StyledNavLink>
            <LanguageButton onClick={() => setIsOpen(false)}>ENG</LanguageButton>
            <DiscoverButton onClick={() => setIsOpen(false)}>JE DÉCOUVRE</DiscoverButton>
          </MobileMenu>
        </>
      )}

      <Content>
        <IconRow>
          <Icon src={Icon2} alt="Icon 2" />
          <Icon src={Icon3} alt="Icon 3" />
          <Icon src={Icon1} alt="Icon 1" />
          <Icon src={Icon4} alt="Icon 4" />
        </IconRow>

        <TitleRow>
          <TitleWrapper>
            <TitleWord ref={word1Ref}>PARTOUCHE</TitleWord>
          </TitleWrapper>
          <TitleWrapper>
            <TitleWord ref={word2Ref}>MULTIVERSE</TitleWord>
          </TitleWrapper>
        </TitleRow>

        <SubtitleWrapper>
          <Subtitle ref={subtitleRef}>
            Et si le jeu ne se vivait pas dans un seul monde ?
          </Subtitle>
        </SubtitleWrapper>

        <IconRow2 id="card-row">
          <IconCard src={C1} alt="Carte 1" />
          <IconCard src={C2} alt="Carte 2" />
          <IconCard src={C3} alt="Carte 3" />
          <IconCard src={C4} alt="Carte 4" />
          <IconCard src={C5} alt="Carte 5" />
        </IconRow2>
      </Content>
    </PageContainer>
  );
};

export default PageCard;